/* Session-only browsing continuity. No tracking or external requests. */
(() => {
  const key = 'z3rone:browse:v1';
  const browseURL = value => {
    try { const u = new URL(value, location.origin); return u.origin === location.origin && /\/(collections(?:\/[^/]+)?|search)\/?$/.test(u.pathname) ? u : null; } catch { return null; }
  };
  const read = () => { try { const item = JSON.parse(sessionStorage.getItem(key)); return item && Date.now() - item.time < 7200000 && browseURL(item.url) ? item : null; } catch { return null; } };
  const apply = () => {
    const item = read();
    document.querySelectorAll('[data-z3-return], [data-z3-continue]').forEach(link => {
      if (!item) return;
      link.href = item.url;
      if (link.hasAttribute('data-z3-return')) {
        const text = link.querySelector('[data-z3-return-text]');
        if (text) text.textContent = (link.dataset.returnPrefix || 'Back to') + ' ' + (item.label || link.dataset.returnFallback || 'shopping');
      }
    });
  };
  const save = () => {
    if (!browseURL(location.href)) return;
    try { sessionStorage.setItem(key, JSON.stringify({url:location.href, y:scrollY, label:(document.querySelector('[data-z3-browse-label]')?.dataset.z3BrowseLabel || document.querySelector('h1')?.textContent || '').trim().slice(0,100), time:Date.now()})); } catch {}
  };
  const restore = () => { const item = read(); if (item && item.url === location.href && new URLSearchParams(location.search).get('page') === new URLSearchParams(item.url.split('?')[1] || '').get('page')) requestAnimationFrame(() => scrollTo(0, item.y || 0)); };
  if (document.readyState === 'complete') restore(); else window.addEventListener('load', restore, {once:true}); apply();
  document.addEventListener('click', event => { if (event.target.closest('[data-z3-continue]')) apply(); if (event.target.closest('a')) save(); });
  window.addEventListener('pagehide', save);
  window.addEventListener('pageshow', apply);
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.z3r0ne-header details[open]').forEach(d => { d.open = false; d.querySelector('summary')?.focus(); });
    document.querySelectorAll('.z3r0ne-menu-toggle[aria-expanded="true"]').forEach(button => { button.click(); button.focus(); });
  });
  document.addEventListener('click', event => { document.querySelectorAll('.z3r0ne-nav details[open]').forEach(d => { if (!d.contains(event.target)) d.open = false; }); });
})();

// Card forms work through native POST without JavaScript; enhance with explicit feedback.
(() => {
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.z3r0ne-card-form')) return;
    const card = form.closest('[data-z3-card-purchase]');
    if (!card || !window.fetch) return;
    event.preventDefault();
    if (form.dataset.submitting === 'true') return;
    const button = form.querySelector('[name="add"]');
    const feedback = card.querySelector('[data-z3-card-feedback]');
    const cartLink = card.querySelector('[data-z3-card-cart-link]');
    const payload = new FormData(form);
    form.dataset.submitting = 'true';
    if (button) button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    feedback.hidden = false;
    feedback.textContent = 'Adding to cart…';
    try {
      const response = await fetch(card.dataset.addUrl, {method:'POST', body:payload, headers:{Accept:'application/json'}});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this option. Please try again.');
      feedback.textContent = 'Added to cart.';
      cartLink.hidden = false;
      // A count refresh failure must never turn a successful add into a false failure.
      try {
        const cartResponse = await fetch(card.dataset.cartUrl, {headers:{Accept:'application/json'}});
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('.z3r0ne-cart-link').forEach(link => {
            let count = link.querySelector('.z3r0ne-cart-count');
            if (!count) { count = document.createElement('span'); count.className = 'z3r0ne-cart-count'; link.append(count); }
            count.textContent = cart.item_count;
            count.setAttribute('aria-label', cart.item_count + ' items in cart');
          });
        }
      } catch {}
    } catch (error) {
      feedback.textContent = error instanceof TypeError ? 'Could not confirm the add. Check your cart before trying again.' : error.message;
      cartLink.hidden = false;
    } finally {
      form.dataset.submitting = 'false';
      form.removeAttribute('aria-busy');
      if (button) button.disabled = false;
    }
  });
})();
